import { styled, Typography } from '@mui/material';

export const ListTitle = styled(Typography, {
  shouldForwardProp: (prop) =>
    prop !== 'hasBiggerTitle' && prop !== 'hasMarginTop',
})(({ theme, hasBiggerTitle, hasMarginTop }) => ({
  fontSize: hasBiggerTitle ? '16px' : '10px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.label,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginBottom: '8px',
  marginTop: hasMarginTop && '16px',
  padding: '0 8px',
  [theme.breakpoints.up('md')]: {
    padding: '0 22px',
  },
}));
